export const PENDING_LOGIN_REDIRECT_KEY = 'hunar_pending_login_redirect';

export function getSafeRedirect(value, fallback = '/shop') {
  const candidate = String(value || '').trim();
  if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) return fallback;
  return candidate;
}
